function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import { getType } from './utils/typeUtils';
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */

export function mergeInto(destination, source) {
  var circularReferenceChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createCircularReferenceChecker();

  // ignore the source if it is undefined
  if (source === undefined) {
    return destination;
  }

  if (_typeof(source) !== 'object' || source === null) {
    // primitive values - just return source
    return source;
  } else if (source instanceof Date) {
    return new Date(source.getTime());
  } else if (source instanceof RegExp) {
    var flags = source.flags || // old browsers compatibility
    [source.global ? 'g' : '', source.ignoreCase ? 'i' : '', source.multiline ? 'm' : '', source.sticky ? 'y' : '', source.unicode ? 'u' : ''].join('');
    return new RegExp(source.source, flags);
  }

  if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
    // remove circular references
    return undefined;
  } else if (Array.isArray(source)) {
    var _merged = Array.isArray(destination) ? destination : [];

    for (var i = 0; i < source.length; ++i) {
      _merged[i] = mergeInto(_merged[i], source[i], circularReferenceChecker);
    }

    return _merged;
  }

  var merged = getType(destination) === 'object' ? destination : {};

  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
    }
  }

  return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */

export function deepClone(value) {
  return mergeInto(undefined, value);
}
export function combine() {
  var destination;

  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];

    // Ignore any undefined or null sources.
    if (source === undefined || source === null) {
      continue;
    }

    destination = mergeInto(destination, source);
  }

  return destination;
}

function createCircularReferenceChecker() {
  if (typeof WeakSet !== 'undefined') {
    var set = new WeakSet();
    return {
      hasAlreadyBeenSeen: function hasAlreadyBeenSeen(value) {
        var has = set.has(value);

        if (!has) {
          set.add(value);
        }

        return has;
      }
    };
  }

  var array = [];
  return {
    hasAlreadyBeenSeen: function hasAlreadyBeenSeen(value) {
      var has = array.indexOf(value) >= 0;

      if (!has) {
        array.push(value);
      }

      return has;
    }
  };
}